import { createContext } from "react";

import { TabsVariantsProps } from "./styles";

type TabsContextType = {
  variant: TabsVariantsProps["variant"];
  lineLayoutId: string;
};

export const TabsContext = createContext<TabsContextType>({
  variant: "default",
  lineLayoutId: "",
});
